<template lang="pug">
.study-result-summary-list
  //- サイドメニュー部
  side-menu.study-result-summary-list__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .study-result-summary-list__content
    breadcrumb-list.study-result-summary-list__content__breadcrumb(
      :breadcrumbs='breadcrumbs',
      :moveEvent='breadcrumbMoveEvent'
    )
    .study-result-summary-list__content__body
      .study-result-summary-list__content__body__heading
        tab-heading.study-result-summary-list__content__body__heading__tab(:isActive='true') {{ titleText }}
      .study-result-summary-list__content__body__main
        .study-result-summary-list__content__body__main__action
          .study-result-summary-list__content__body__main__action__button
            button-icon-circle.study-result-summary-list__content__body__main__action__button__icon(
              type='download',
              @click='downloadEvent'
            )
              slot(name='downloadIconLabel')
        study-result-summary-table.study-result-summary-list__content__body__main__table(
          v-if='userResultDatas',
          :resultButtonEvent='resultButtonEvent',
          :lastMinuteCheckResultLinkEvent='lastMinuteCheckResultLinkEvent',
          :resolveResultLinkEvent='resolveResultLinkEvent',
          :userResultDatas='userResultDatas'
        )
          template(#subjectNameHeader)
            slot(name='subjectNameHeader')
          template(#sUnitNameHeader)
            slot(name='sUnitNameHeader')
          template(#resultHeader)
            slot(name='resultHeader')
          template(#lastMinuteCheckResultHeader)
            slot(name='lastMinuteCheckResultHeader')
          template(#resolveResultHeader)
            slot(name='resolveResultHeader')
          template(#resultButtonLabel)
            slot(name='resultButtonLabel')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import TabHeading from '@/components/molecules/manager/TabHeading.vue'
import ButtonIconCircle from '@/components/molecules/manager/ButtonIconCircle.vue'
import StudyResultSummaryTable from '@/components/organisms/manager/StudyResultSummaryTable.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { StudyResultListType, StudyResultSummaryListType } from '@/models/studyResultListModel'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'

/**
 * 管理画面・生徒の成績表画面
 */
@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    TabHeading,
    ButtonIconCircle,
    StudyResultSummaryTable,
  },
})
export default class StudyResultSummaryList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // パンくず遷移イベント
  @Prop()
  breadcrumbMoveEvent!: Function

  // ダウンロードボタン押下時イベント
  @Prop()
  downloadEvent!: Function

  // 結果ボタン押下イベント
  @Prop()
  resultButtonEvent!: Function

  // 直前チェック結果リンク押下イベント
  @Prop()
  lastMinuteCheckResultLinkEvent!: Function

  // 解きなおし結果リンク押下イベント
  @Prop()
  resolveResultLinkEvent!: Function

  // 生徒履歴情報
  @Prop()
  studyResultList!: StudyResultListType[]

  // タイトル名取得
  private get titleText() {
    return this.studyResultList ? this.studyResultList[0].title : ''
  }

  // サマリー一覧取得
  private get userResultDatas(): StudyResultSummaryListType[] | null {
    return this.studyResultList ? this.studyResultList[0].summaries : null
  }
}
</script>

<style lang="stylus" scoped>
.study-result-summary-list
  display flex
  width 100%
  height 100%

  &__content
    width 100%
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 20px
    overflow-y auto

    &__body
      display flex
      flex-direction column

      &__heading
        display flex
        height 43px

      &__main
        z-index 1
        width 100%
        min-height 500px
        display flex
        flex-direction column
        border-radius 0px 15px 15px 15px
        background var(--color-manager-list__background)
        box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)

        &__action
          display flex
          justify-content flex-end
          align-items center
          padding 28px 20px

          &__button
            display flex
            gap 12px

            &__icon
              width 32px
              height 32px

        &__table
          margin-bottom 40px
</style>
